import packageJson from '../../package.json';

export const environment = {
  production: false,
  appName: 'LyricStream',
  name: 'QA',
  description: 'QA Environment',
  version: packageJson.version,

  // LyricStream API
  apiUrl: 'https://middleware.qa.lyricstream.app',
  apiUrlProxy: 'https://middleware.lyricstream.app',
  wsUrl: 'wss://middleware.lyricstream.app',
  websocketUrl: 'wss://middleware.qa.lyricstream.app',

  // Hub SignalR d'EngagementService (notifications en direct : relais nginx /hubs/ derrière le Middleware en QA/prod).
  // Vide = pas de push, rafraîchissement périodique seulement.
  engagementHubUrl: 'wss://middleware.qa.lyricstream.app/hubs/notifications',

  // Keycloak Authentication
  keycloakUrl: 'https://auth.qa.lyricstream.app',
  keycloakRealm: 'lyricstream',
  keycloakClientId: 'lyricstream-web-public',

  // Legacy (à migrer/supprimer)
  serverPathApi: 'https://api.ccg.qa.grafritz.com',
  serverPathWeb: 'https://lyrics.rezo509.com',
  serverAdminPathWeb: 'https://lyrics.rezo509.com',

  // Cloudflare Web Analytics (sans cookie) : jeton du site, copié depuis
  // dash.cloudflare.com → Analytics & Logs → Web Analytics → Add a site → snippet JS manuel.
  // Vide = script non chargé.
  cloudflareAnalyticsToken: '42b5660e20244f0aa5edd7a9d0af79d2', // site qa.lyricstream.app

  // Google Analytics 4 : ID de mesure (G-XXXXXXX), créé dans analytics.google.com.
  // Chargé SEULEMENT après acceptation du bandeau de consentement (Loi 25 / RGPD).
  // Vide = ni bandeau ni Google Analytics.
  googleAnalyticsId: 'G-6L7D6GMKL7', // propriété GA4 « LyricStream QA » distincte de PROD (qa.lyricstream.app)

  // Features flags
  features: {
    analytics: true,
    userManagement: false,
    contentModeration: false,
    systemSettings: false,
    socialSharing: true,
    userPlaylists: true,
    karaoke: true,
    lyricsProjection: true,
    fullWidthPanelAdmin: false,
  },

  // Largeur de mise en page (header/footer/body), configurable sans toucher au code --
  // cf. decision utilisateur "je veux pouvoir le configurer dans un fichier app config".
  layout: {
    headerFullWidth: false,
    footerFullWidth: false,
    bodyFullWidth: false,
    maxWidth: '1280px',//'1440px',
  },
};
